import Phaser from 'phaser';
import PlayerCharacter from '../components/player/PlayerCharacter';
import { loadSceneSprites, loadChestSprites, loadGenericSprites, loadCropSprites, loadPlotSignSprites, loadMobSprites, loadWeaponSprites, loadUISprites } from '../util/Animations';
import { itemManager } from '../managers/ItemManager';

export default class LoadingScene extends Phaser.Scene {
    constructor() {
        super({ key: 'LoadingScene' });
        this.loadingProgress = 0;
    }

    preload() {
        // Setup loading progress tracking
        this.load.on('progress', (value) => {
            this.loadingProgress = value;
            this.updateProgressBar(value);
        });



        // Set camera viewport to game area BEFORE fade effects
        this.cameras.main.setViewport(0, 0, 256, 192);

        // Start fade in effect (now constrained to 256x192)
        this.cameras.main.fadeIn(800, 0, 0, 0);

        // Create loading UI
        this.createLoadingUI();

        // Load all game assets here
        this.loadAllAssets();

        this.load.on('complete', () => {
            // console.log('All assets loaded, transitioning to game...');
            this.transitionToGame();
        });
    }

    createLoadingUI() {
        // Use the proper game area dimensions (256x192) instead of full canvas
        const gameWidth = 256;
        const gameHeight = 192;
        const centerX = gameWidth / 2;
        const centerY = gameHeight / 2;

        // Background - only fill the game area, not the full canvas
        this.add.rectangle(centerX, centerY, gameWidth, gameHeight, 0x1a1a1a);

        // Title
        this.add.text(centerX, centerY - 60, 'BINAGOTCHI', {
            fontSize: '24px',
            color: '#ffffff',
            fontFamily: 'Arial'
        }).setOrigin(0.5);

        // Loading text
        this.loadingText = this.add.text(centerX, centerY - 20, '正在加载 Loading...', {
            fontSize: '16px',
            color: '#ffffff',
            fontFamily: 'Arial'
        }).setOrigin(0.5);

        // Progress bar background
        this.progressBarBg = this.add.rectangle(centerX, centerY + 20, 200, 20, 0x333333);
        this.progressBarBg.setStrokeStyle(2, 0x666666);

        // Progress bar fill
        this.progressBar = this.add.rectangle(centerX - 100, centerY + 20, 0, 16, 0x00ff00);
        this.progressBar.setOrigin(0, 0.5);

        // Percentage text
        this.percentageText = this.add.text(centerX, centerY + 50, '0%', {
            fontSize: '14px',
            color: '#ffffff',
            fontFamily: 'Arial'
        }).setOrigin(0.5);
    }

    updateProgressBar(progress) {
        const percentage = Math.round(progress * 100);
        this.percentageText.setText(`${percentage}%`);
        
        // Update progress bar width
        this.progressBar.width = progress * 200;
        
        // Update loading text with specific loading phases
        if (progress < 0.3) {
            this.loadingText.setText('Loading sprites...');
        } else if (progress < 0.6) {
            this.loadingText.setText('Loading audio...');
        } else if (progress < 0.9) {
            this.loadingText.setText('Loading scenes...');
        } else {
            this.loadingText.setText('Almost ready...');
        }
    }

    loadAllAssets() {
        // Load all player character assets
        PlayerCharacter.preloadAssets(this);

        // Load item assets (fish, consumables, etc.)
        //itemManager.preloadAssets(this);

        // Load scene sprites
        loadSceneSprites(this);

        // Load crop sprites
        loadCropSprites(this);

        // Load generic sprites
        loadGenericSprites(this);

        // Load chest sprites
        //loadChestSprites(this);

        // Load plot sign sprites
        loadPlotSignSprites(this);

        loadWeaponSprites(this);
        // Load mob sprites
        loadMobSprites(this);

        loadUISprites(this);

        // Load UI assets
        this.load.spritesheet('win98window', '/sprites/ui/windows98window.png', {
            frameWidth: 200,
            frameHeight: 180
        });

        /// Fonts
        /* 
        this.load.bitmapFont('KiwiSoda', '/fonts/kiwisoda/Kiwisoda.png', '/fonts/kiwisoda/Kiwisoda.xml');
        this.load.bitmapFont('04b_30', '/fonts/04b_30/04b_30.png', '/fonts/04b_30/04b_30.xml');
        this.load.bitmapFont('Birchleaf', '/fonts/Birchleaf/Birchleaf.png', '/fonts/Birchleaf/Birchleaf.xml');
        this.load.bitmapFont('Cavalhatriz', '/fonts/Cavalhatriz/Cavalhatriz.png', '/fonts/Cavalhatriz/Cavalhatriz.xml');
        this.load.bitmapFont('Daydream', '/fonts/Daydream/Daydream.png', '/fonts/Daydream/Daydream.xml');
        this.load.bitmapFont('Deltarune', '/fonts/Deltarune/Deltarune.png', '/fonts/Deltarune/Deltarune.xml');
        this.load.bitmapFont('EmojiFont', '/fonts/EmojiFont/EmojiFont.png', '/fonts/EmojiFont/EmojiFont.xml');
        this.load.bitmapFont('GothicByte', '/fonts/GothicByte/GothicByte.png', '/fonts/GothicByte/GothicByte.xml');
        this.load.bitmapFont('GothicPixels', '/fonts/GothicPixels/GothicPixels.png', '/fonts/GothicPixels/GothicPixels.xml');
        this.load.bitmapFont('GrapeSoda', '/fonts/GrapeSoda/GrapeSoda.png', '/fonts/GrapeSoda/GrapeSoda.xml');
        this.load.bitmapFont('MonsterFriendFore', '/fonts/MonsterFriendFore/MonsterFriendFore.png', '/fonts/MonsterFriendFore/MonsterFriendFore.xml');
        this.load.bitmapFont('PixelOperator', '/fonts/PixelOperator/PixelOperator.png', '/fonts/PixelOperator/PixelOperator.xml');
        this.load.bitmapFont('pixelpoiiz', '/fonts/pixelpoiiz/pixelpoiiz.png', '/fonts/pixelpoiiz/pixelpoiiz.xml');
        this.load.bitmapFont('SD-Auto-Pilot', '/fonts/SD-Auto-Pilot/SD-Auto-Pilot.png', '/fonts/SD-Auto-Pilot/SD-Auto-Pilot.xml');
        */
        this.load.bitmapFont('VCROSDMono', '/fonts/bitmap/VCROSDMono/VCROSDMono.png', '/fonts/bitmap/VCROSDMono/VCROSDMono.xml');

        // Load MainScene assets
        this.load.image('pad', '/sprites/solagatchipad.png');
        this.load.image('rocky', '/sprites/rocky.png');
        this.load.image('sliding_door', '/sprites/sliding_door.png');
        this.load.image('crystal', '/sprites/scenes/crystal.png');

        // Load FarmScene assets
        this.load.image('farm_map', '/sprites/farming/farm_512x384.png');
        this.load.image('farm_fence', '/sprites/farming/farm_fence_512x384.png');
        this.load.image('farm_collision', '/sprites/farming/farm_collision_512x384.png');
        this.load.image('farmplot_locked', '/sprites/farming/farmplot_locked_160x80.png');
        this.load.image('farmplot_unlocked', '/sprites/farming/farmplot_unlocked_160x80.png');
        this.load.image('coop_locked', '/sprites/farming/coop_locked.png');
        this.load.image('coop_unlocked', '/sprites/farming/coop_unlocked.png');
        this.load.image('dungeonfence', '/sprites/farming/dungeonfence.png');
        this.load.image('watered_patch', '/sprites/farming/watered_patch_16x16.png');
        this.load.image('farm_tile_raw', '/sprites/farming/farm-tile-raw.png');
        this.load.image('farm_tile_watered', '/sprites/farming/farm-tile-watered.png');
        this.load.image('chest_stationary', '/sprites/chest3.png');

        // Load watering can water animation (54x8 spritesheet, 9 frames of 6x8 each)
        this.load.spritesheet('tool-wateringcan-water', '/sprites/ui/tools/tool-wateringcan-water_6x8.png', {
            frameWidth: 6,
            frameHeight: 8
        });

        // Load RiverScene assets
        this.load.image('river', '/sprites/River_new.png');
        this.load.image('river_new_bridge_locked', '/sprites/river_new_bridge_locked.png');
        //this.load.image('river_new_bridge_unlocked', '/sprites/river/river_new_bridge_locked.png');
        this.load.image('barricade', '/sprites/barricade.png');

        // Load BeachScene assets
        this.load.spritesheet('beach', '/sprites/tilesets/beach.png', {
            frameWidth: 256,
            frameHeight: 192
        });
        this.load.image('beachCollision', '/sprites/tilesets/beachCollision.png');
        
        // Load Combat1Scene assets
        this.load.image('combat_scene_1', '/sprites/combat/combat_scene_1.png');
        this.load.image('healing_font_empty', '/sprites/combat/objects/healingfont_empty.png');

        // Load fishing assets
        this.load.spritesheet('fishingRod', '/sprites/items/tools/fishingRodCast.png', {
            frameWidth: 160,
            frameHeight: 90
        });
        this.load.spritesheet('ripple', '/sprites/fishing/ripple.png', {
            frameWidth: 16,
            frameHeight: 6
        });
        this.load.spritesheet('bobberFloating', '/sprites/fishing/bobberFloating.png', {
            frameWidth: 16,
            frameHeight: 24
        });
        this.load.spritesheet('bobberBite', '/sprites/fishing/bobberBite.png', {
            frameWidth: 16,
            frameHeight: 24
        });

        // Load fishing minigame assets
        this.load.spritesheet('minigameFrame', '/sprites/fishing/minigameFrame.png', {
            frameWidth: 114,
            frameHeight: 18
        });
        this.load.spritesheet('gaugeFill', '/sprites/fishing/gaugeFill.png', {
            frameWidth: 114,
            frameHeight: 9
        });
        this.load.spritesheet('gaugeFrame', '/sprites/fishing/gaugeFrame.png', {
            frameWidth: 114,
            frameHeight: 9
        });
        this.load.spritesheet('minigameFish', '/sprites/fishing/minigameFish.png', {
            frameWidth: 14,
            frameHeight: 6
        });
        this.load.spritesheet('fishOverlapGreen', '/sprites/fishing/fishOverlapGreen.png', {
            frameWidth: 16,
            frameHeight: 8
        });
        this.load.spritesheet('fishOverlapYellow', '/sprites/fishing/fishOverlapYellow.png', {
            frameWidth: 16,
            frameHeight: 8
        });
        this.load.spritesheet('fishOverlapRed', '/sprites/fishing/fishOverlapRed.png', {
            frameWidth: 16,
            frameHeight: 8
        });

        // Load all audio assets
        this.loadAudioAssets();

        // Load UI and dialogue assets
        this.loadUIAssets();
        
        // Load stats sprites
        this.loadStatsSprites();
    }

    loadStatsSprites() {
        // Load stat sprites for the menu bar
        this.load.spritesheet('hunger', '/sprites/solagotchi/hunger.png', {
            frameWidth: 16,
            frameHeight: 16
        });
        this.load.spritesheet('health', '/sprites/solagotchi/health.png', {
            frameWidth: 16,
            frameHeight: 16
        });
        this.load.spritesheet('energy', '/sprites/solagotchi/energy.png', {
            frameWidth: 16,
            frameHeight: 16
        });
    }



    loadAudioAssets() {
        // Background music
        this.load.audio('bgm1', '/audio/bgm/bgm1.mp3');
        this.load.audio('bgm2', '/audio/bgm/bgm2.mp3');
        this.load.audio('bgm3', '/audio/bgm/bgm3.mp3');
        this.load.audio('bgm4', '/audio/bgm/bgm4.mp3');
        this.load.audio('bgm5', '/audio/bgm/bgm5.mp3');
        this.load.audio('bgm6', '/audio/bgm/bgm6.mp3');
        this.load.audio('dungeonBgm1', '/audio/bgm/dungeonBgm1.mp3');
        this.load.audio('dungeonBgm2', '/audio/bgm/dungeonBgm2.mp3');

        // UI sounds
        this.load.audio('98ding', '/audio/sfx/98ding.mp3');
        this.load.audio('98chord', '/audio/sfx/98chord.mp3');
        this.load.audio('98notify', '/audio/sfx/98notify.mp3');
        this.load.audio('98tada', '/audio/sfx/98tada.mp3');
        this.load.audio('lgg', '/audio/sfx/lgg.mp3');
        this.load.audio('rock_slide', '/audio/sfx/rock-door.mp3');
        this.load.audio('success', '/audio/sfx/success.mp3');
        this.load.audio('success2', '/audio/sfx/success2.mp3');
        this.load.audio('win', '/audio/sfx/win.mp3');
        this.load.audio('bigwin', '/audio/sfx/big-win.mp3');
        this.load.audio('biggerwin', '/audio/sfx/bigger-win.mp3');
        this.load.audio('lose', '/audio/sfx/lose.mp3');

        // Walking sfx
        this.load.audio('footsteps1', '/audio/sfx/walking/walking-1.mp3');
        this.load.audio('footsteps2', '/audio/sfx/walking/walking-2.mp3');
        this.load.audio('footsteps3', '/audio/sfx/walking/walking-3.mp3');
        this.load.audio('footsteps4', '/audio/sfx/walking/walking-4.mp3');
        this.load.audio('footsteps5', '/audio/sfx/walking/walking-5.mp3');

        // Fishing sounds
        this.load.audio('river_ambiance', '/audio/sfx/river.mp3');
        this.load.audio('cast', '/audio/sfx/fishing/cast.mp3');
        this.load.audio('splash', '/audio/sfx/fishing/splash.mp3');
        this.load.audio('reelingStart', '/audio/sfx/fishing/reelingStart.mp3');
        this.load.audio('reeling', '/audio/sfx/fishing/reeling.mp3');
        this.load.audio('catchSplash', '/audio/sfx/fishing/catchSplash.mp3');
        this.load.audio('caught1', '/audio/sfx/fishing/caught1.mp3');
        this.load.audio('caught2', '/audio/sfx/fishing/caught2.mp3');
        this.load.audio('caught3', '/audio/sfx/fishing/caught3.mp3');
        this.load.audio('caught4', '/audio/sfx/fishing/caught4.mp3');
        this.load.audio('lost', '/audio/sfx/fishing/lost.mp3');

        // FARMING SOUNDS
        // TOOLS
        this.load.audio('hoe-hit-1', '/audio/sfx/tools/hoe-hit-1.mp3');
        this.load.audio('hoe-hit-2', '/audio/sfx/tools/hoe-hit-2.mp3');
        this.load.audio('scythe-swing-1', '/audio/sfx/tools/scythe-swing-1.mp3');
        this.load.audio('scythe-swing-2', '/audio/sfx/tools/scythe-swing-2.mp3');
        this.load.audio('scythe-swing-3', '/audio/sfx/tools/scythe-swing-3.mp3');
        this.load.audio('seed-packet-select', '/audio/sfx/tools/seed-packet-select.mp3');
        this.load.audio('seed-packet-sow', '/audio/sfx/tools/seed-packet-sow.mp3');
        this.load.audio('watering-can-fill', '/audio/sfx/tools/watering-can-fill.mp3');
        this.load.audio('watering-can-pour-1', '/audio/sfx/tools/watering-can-pour-1.mp3');
        this.load.audio('watering-can-pour-2', '/audio/sfx/tools/watering-can-pour-2.mp3');

        // CROPS
        this.load.audio('harvest-crop-1', '/audio/sfx/tools/harvest-crop-1.mp3');
        this.load.audio('harvest-crop-2', '/audio/sfx/tools/harvest-crop-2.mp3');
        this.load.audio('crop-pickup-1', '/audio/sfx/tools/crop-pickup-1.mp3');
        this.load.audio('crop-pickup-2', '/audio/sfx/tools/crop-pickup-2.mp3');

        // SEEDBAGS & MUTANT CROPS
        this.load.audio('seedbag-spawn', '/audio/sfx/tools/seedbag-spawn.mp3');
        this.load.audio('mutant-wow', '/audio/sfx/tools/wow.mp3');

        // FARMING SOUNDS

        // Environment sounds
        this.load.audio('beach', '/audio/sfx/beach.mp3');
        this.load.audio('farm', '/audio/sfx/farm.mp3');

        // Inventory sounds
        this.load.audio('openInventory', '/audio/sfx/inventory/openInventory.wav');
        this.load.audio('rustle01', '/audio/sfx/inventory/rustle01.wav');
        this.load.audio('sell-item', '/audio/sfx/inventory/sell-item.mp3');
        
        // Chest sounds
        this.load.audio('chest_open', '/audio/sfx/chest_open.mp3');
        this.load.audio('chest_close', '/audio/sfx/chest_close.mp3');
        
        // COMBAT SOUNDS
        /////////////////
        // Player
        this.load.audio('healing-font', '/audio/sfx/combat/healing-font.mp3');
        this.load.audio('solagotchi-hurt-1', '/audio/sfx/combat/solagotchi-hurt-1.mp3');
        this.load.audio('solagotchi-hurt-2', '/audio/sfx/combat/solagotchi-hurt-2.mp3');
        this.load.audio('solagotchi-hurt-3', '/audio/sfx/combat/solagotchi-hurt-3.mp3');
        this.load.audio('sword-swing-1', '/audio/sfx/combat/sword-swing-1.mp3');
        this.load.audio('sword-swing-2', '/audio/sfx/combat/sword-swing-2.mp3');

        // Zombie
        this.load.audio('zombie-attack-1', '/audio/sfx/combat/zombie-attack-1.mp3');
        this.load.audio('zombie-attack-2', '/audio/sfx/combat/zombie-attack-2.mp3');
        this.load.audio('zombie-attack-3', '/audio/sfx/combat/zombie-attack-3.mp3');
        this.load.audio('zombie-attack-4', '/audio/sfx/combat/zombie-attack-3.mp3');
        this.load.audio('zombie-idle-1', '/audio/sfx/combat/zombie-idle-1.mp3');
        this.load.audio('zombie-hurt-1', '/audio/sfx/combat/zombie-hurt-1.mp3');
        this.load.audio('zombie-hurt-2', '/audio/sfx/combat/zombie-hurt-2.mp3');
        this.load.audio('zombie-death-1', '/audio/sfx/combat/zombie-death-1.mp3');
        this.load.audio('zombie-death-2', '/audio/sfx/combat/zombie-death-2.mp3');
        this.load.audio('poison-zombie-shoot-1', '/audio/sfx/combat/poison-zombie-shoot-1.mp3');
        this.load.audio('poison-zombie-shoot-2', '/audio/sfx/combat/poison-zombie-shoot-2.mp3');
        this.load.audio('poison-zombie-hit-1', '/audio/sfx/combat/poison-zombie-hit-1.mp3');
        this.load.audio('bomb-zombie-death', '/audio/sfx/combat/bomb-zombie-death.mp3');
        // Ranged sounds
        this.load.audio('bow-draw', '/audio/sfx/combat/bow-draw.mp3');
        this.load.audio('bow-fire-A1', '/audio/sfx/combat/bow-fire-A1.mp3');
        this.load.audio('bow-fire-A2', '/audio/sfx/combat/bow-fire-A2.mp3');
        this.load.audio('bow-fire-B', '/audio/sfx/combat/bow-fire-B.mp3');
        this.load.audio('arrow-stuck', '/audio/sfx/combat/arrow-stuck.mp3');
        
        // Combat/dialogue sounds for bosses and special characters
        this.load.audio('skeleton-knight-1', '/audio/sfx/combat/skeleton-knight-1.mp3');
        this.load.audio('skeleton-knight-2', '/audio/sfx/combat/skeleton-knight-2.mp3');
        this.load.audio('skeleton-knight-3', '/audio/sfx/combat/skeleton-knight-3.mp3');
        this.load.audio('skeleton-knight-shield-clang', '/audio/sfx/combat/skeleton-knight-shield-clang.mp3');
        this.load.audio('skeleton-knight-swing-1', '/audio/sfx/combat/skeleton-knight-swing-1.mp3');
        this.load.audio('skeleton-knight-swing-2', '/audio/sfx/combat/skeleton-knight-swing-2.mp3');
        this.load.audio('skeleton-knight-hurt-1', '/audio/sfx/combat/skeleton-knight-hurt-1.mp3');
        this.load.audio('skeleton-knight-hurt-2', '/audio/sfx/combat/skeleton-knight-hurt-2.mp3');
        this.load.audio('skeleton-knight-death', '/audio/sfx/combat/skeleton-knight-death.mp3');

    }

    loadUIAssets() {
        // Dialogue assets
        this.load.image('dialoguePanel', '/sprites/ui/Dialogue/DialoguePanel.png');
        this.load.spritesheet('dialogueDots', '/sprites/ui/Dialogue/dialogueDots.png', {
            frameWidth: 16,
            frameHeight: 16
        });

        // Emote assets
        const emotes = ['angry', 'asleep', 'basic', 'complete', 'cool', 'dead', 'exclamation', 'happy', 'love', 'question', 'sad'];
        emotes.forEach(emote => {
            this.load.image(`emote_${emote}`, `/sprites/ui/Dialogue/Emotes/${emote}.png`);
        });

        // Dialogue option button assets
        this.load.image('dialogue-option-accept', '/sprites/ui/Dialogue/dialogue-option-accept.png');
        this.load.image('dialogue-option-accept-hovered', '/sprites/ui/Dialogue/dialogue-option-accept-hovered.png');
        this.load.image('dialogue-option-accept-selected', '/sprites/ui/Dialogue/dialogue-option-accept-selected.png');
        this.load.image('dialogue-option-decline', '/sprites/ui/Dialogue/dialogue-option-decline.png');
        this.load.image('dialogue-option-decline-hovered', '/sprites/ui/Dialogue/dialogue-option-decline-hovered.png');
        this.load.image('dialogue-option-decline-selected', '/sprites/ui/Dialogue/dialogue-option-decline-selected.png');

        // Menu and inventory UI
        this.load.image('menu-bg', '/sprites/ui/Menu/MenuBG_Wood.png');
        this.load.image('inventory-icon', '/sprites/ui/Icons/132.png');
        this.load.image('equipment-icon', '/sprites/ui/Icons/41.png');
        this.load.image('stats-icon', '/sprites/ui/Icons/250.png');
        this.load.image('map-icon', '/sprites/ui/Icons/globe.png');
        this.load.image('quests-icon', '/sprites/ui/Icons/282.png');
        this.load.image('leaderboard-icon', '/sprites/ui/Icons/283.png');
        this.load.image('settings-icon', '/sprites/ui/Icons/266.png');

        // Inventory UI assets
        this.load.image('invSq', '/sprites/ui/inventory/invSq.png');
        this.load.image('itemFrameNormal', '/sprites/ui/inventory/itemFrameNormal.png');
        this.load.image('itemFrameUncommon', '/sprites/ui/inventory/itemFrameUncommon.png');
        this.load.image('itemFrameRare', '/sprites/ui/inventory/itemFrameRare.png');
        this.load.image('itemFrameEpic', '/sprites/ui/inventory/itemFrameEpic.png');
        this.load.image('itemFrameLegendary', '/sprites/ui/inventory/itemFrameLegendary.png');
        this.load.image('itemFrameJunk', '/sprites/ui/inventory/itemFrameJunk.png');
        this.load.image('itemFrameQuest', '/sprites/ui/inventory/itemFrameQuest.png');

        // Tool UI assets
        this.load.image('tool-ui', '/sprites/ui/tools/tool-ui.png');
        this.load.image('tool-ui-icon-empty-hover', '/sprites/ui/tools/tool-ui-icon-empty-hover.png');
        
        // New tool selection and seedbag UI assets
        this.load.image('tool-selection-ui', '/sprites/ui/tools/tool-selection-ui.png');
        this.load.image('seedbag-ui', '/sprites/ui/tools/seedbag-ui.png');
        // Vendor UI assets
        this.load.image('seed-vendor-ui', '/sprites/ui/vendors/seed-vendor-ui.png');
        
        // Tool icons (17x17 pixels)
        this.load.image('tool-watering-can', '/sprites/ui/tools/tool-wateringcan.png');
        this.load.image('tool-axe', '/sprites/ui/tools/tool-axe.png');
        this.load.image('tool-pickaxe', '/sprites/ui/tools/tool-pickaxe.png');
        this.load.image('tool-hoe', '/sprites/ui/tools/tool-hoe.png');
        this.load.image('tool-scythe', '/sprites/ui/tools/tool-scythe.png');
        
        // Weapon UI
        this.load.image('weapon-selection-ui', '/sprites/ui/tools/weapon-selection-ui.png');
        //this.load.image('cooldown_timer', '/sprites/ui/tools/cooldown-timer.png');

        // Weapon icons - load using textureKeys from items.json
        this.load.image('basic_sword', '/sprites/ui/weapons/sword1.png');
        this.load.image('weapon_sword_curved', '/sprites/ui/weapons/sword2.png');
        this.load.image('weapon_sword_gold_rapier', '/sprites/ui/weapons/sword3.png');
        this.load.image('weapon_enchanted_blade', '/sprites/ui/weapons/sword4.png');
        this.load.image('weapon_bow_basic', '/sprites/ui/weapons/bow.png');
        
        // Ammo sprites
        this.load.image('ammo_arrow_basic', '/sprites/ui/weapons/arrow.png');
        this.load.image('ammo_arrow_gold', '/sprites/ui/weapons/arrow_gold.png');
        
        // Generic fallback weapon sprites
        this.load.image('sword', '/sprites/ui/weapons/sword1.png');
        this.load.image('bow', '/sprites/ui/weapons/bow.png');
        this.load.image('arrow', '/sprites/ui/weapons/arrow.png');
        
    }



    transitionToGame() {
        // Add a slight delay to let the user see 100% completion
        this.time.delayedCall(500, () => {
            this.loadingText.setText('Ready!');
            
            // Fade out loading scene
            this.cameras.main.fadeOut(800, 0, 0, 0);
            
            this.cameras.main.once('camerafadeoutcomplete', () => {
                // Start the combat scene for testing
                this.scene.start('Farm');
            });
        });
    }

    create() {
        // This runs after preload completes, but we handle everything in preload
        // Camera viewport is already set in preload() before fade effects
    }
} 